// extracted by mini-css-extract-plugin
export default {"small":"734px","medium":"868px","app":"app_app__hD-qr","content":"app_content__Lbm81","light":"app_light__9F2u9","dark":"app_dark__Exya3","root_colors":"app_root_colors__Bf+tc"};